import BipolarEmail from './BipolarEmail';

export default BipolarEmail;
